import DeleteEventView from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  computed: {
    selectedEvent() {
      return this.$store.getters["pages/plan/getSelectedRecruitmentEvent"];
    }
  },
  methods: {
    handleClickDeleteEventViewClose() {
      this.$store.commit("pages/plan/updateDeleteEventView", {
        isVisible: false
      });
    },
    handleEditEventViewClose() {
      this.$store.commit("pages/plan/updateEditEventView", {
        isVisible: false
      });
    },
    handleClickCancel() {
      if (!this.selectedEvent) {
        return;
      }
      this.handleClickDeleteEventViewClose();
    },
    async handleClickDelete() {
      if (!this.selectedEvent) {
        return;
      }
      try {
        const partnerUser = this.$store.state.domains.user.partnerUser;
        const planId = this.$route.params["planId"];
        const recruitmentEventId = this.selectedEvent.id;
        if (!partnerUser || !planId || !recruitmentEventId) {
          return;
        }
        await this.$store.dispatch("domains/plan/deleteEvent", {
          partner_id: partnerUser.partner.id,
          plan_id: Number(planId),
          recruitment_event_id: recruitmentEventId
        });
        this.handleClickDeleteEventViewClose();
        this.handleEditEventViewClose();
        this.$emit("delete");
      } catch (error) {
        throw error;
      }
    }
  },
  render(createElement) {
    return createElement(DeleteEventView, {
      on: {
        clickDelete: this.handleClickDelete,
        clickCancel: this.handleClickCancel
      },
      props: {
        selectedEvent: this.selectedEvent
      }
    });
  }
});
